import React from 'react';

import Button, { type IconProp } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	loadMoreButton: {
		marginBlockStart: token('space.100'),
	},
});

export const MoreLessButton = ({
	label,
	onClick,
	iconBefore,
}: {
	label: string;
	onClick: () => void;
	iconBefore: IconProp;
}): React.JSX.Element => {
	return (
		<Box xcss={styles.loadMoreButton}>
			<Button iconBefore={iconBefore} appearance="subtle" onClick={onClick}>
				{label}
			</Button>
		</Box>
	);
};
